import { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { AuthShell, AuthCard, AuthInput, AuthButton, AuthError, AuthSuccess } from '../components/AuthShell';

export function ConfirmSignUpPage() {
  const loc = useLocation();
  const nav = useNavigate();
  const { confirmSignUp, resendCode, loading, error, clearError } = useAuthStore();
  const [email, setEmail] = useState((loc.state as any)?.email ?? '');
  const returnUrl: string = (loc.state as any)?.returnUrl ?? '';
  const [code, setCode] = useState('');
  const [resentMsg, setResentMsg] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    const r = await confirmSignUp(email.trim().toLowerCase(), code.trim());
    if (r.ok) {
      const loginPath = returnUrl ? `/login?returnUrl=${encodeURIComponent(returnUrl)}` : '/login';
      nav(loginPath, { state: { email } });
    }
  };

  return (
    <AuthShell>
      <AuthCard title="Verify your email" subtitle={`We sent a 6-digit code to ${email || 'your email'}.`}>
        <form onSubmit={submit} className="space-y-4">
          <p className="text-xs text-slate-400">Can't find the email? Check your spam or junk folder.</p>
          {!loc.state?.email && <AuthInput type="email" label="Email" value={email} onChange={setEmail} required />}
          <AuthInput label="6-digit code" value={code} onChange={setCode} required autoFocus placeholder="123456" />
          {error && <AuthError message={error} />}
          {resentMsg && <AuthSuccess message={resentMsg} />}
          <AuthButton type="submit" loading={loading}>Verify and continue</AuthButton>
        </form>
        <div className="mt-5 flex items-center justify-between text-sm">
          <button
            type="button"
            onClick={async () => {
              await resendCode(email).catch(() => {});
              setResentMsg('New code sent. Check your email.');
            }}
            className="text-squishy-primary hover:underline"
          >Resend code</button>
          <Link to="/login" className="text-slate-500 hover:underline">Back to sign in</Link>
        </div>
      </AuthCard>
    </AuthShell>
  );
}
